import React, { FC } from 'react';
import { Box, IconButton } from '@mui/material';
import { useUiContext } from 'src/UIProvider';
import { FileDropzone } from 'src/UIKit/FileDropzone';
import { Iconify } from 'src/UIKit/Iconify';
import { Image } from 'src/UIKit/Image';
import { observer } from 'mobx-react';
import { newsModel } from 'src/modules/news/entity/news/NewsModel';

export const NewsImageDropZone: FC = observer(() => {
    const { t, colors } = useUiContext();
    const news = newsModel.newsOne;

    const onChangeImage = (files: File[]) => {
        if (news && files?.[0]) {
            newsModel.newsOne = { ...news, image: files?.[0] as any };
        }
    }

    const omRemoveImage = () => {
        if (news) {
            newsModel.newsOne = { ...news, image: null as any };
        }
    }

    return (
        <Box>
            {
                news?.image
                    ? <Box sx={{ position: 'relative', display: 'flex', flex: 1, justifyContent: 'center' }}>
                        <Image image={news?.image} sx={{ alignSelf: 'center', display: 'flex', flex: 1, borderRadius: 1.5, objectFit: 'contain' }} />
                        <IconButton
                            sx={{
                                height: 40, width: 40, backgroundColor: colors.card, position: 'absolute', right: '10px', top: '10px'
                            }}
                            onClick={omRemoveImage} >
                            <Iconify icon={'eva:trash-2-outline'} />
                        </IconButton>
                    </Box >
                    : <FileDropzone onDrop={onChangeImage} />
            }
        </Box>
    );
})
